import { render } from "./VirtualRedTagVerifyTrailer.vue?vue&type=template&id=d995dbc8&scoped=true&ts=true"
import script from "./VirtualRedTagVerifyTrailer.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagVerifyTrailer.vue?vue&type=script&lang=ts"

import "./VirtualRedTagVerifyTrailer.vue?vue&type=style&index=0&id=d995dbc8&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d995dbc8"]])

export default __exports__